import React, { useEffect, useState } from 'react'
import './Videos.css'
const Videos = ({id}) => {
    
    const [video,setVideo]=useState({});
    useEffect(()=>{
        getVideo();
    },[id]);

   async function getVideo(){
    const data=await fetch(`https://api.themoviedb.org/3/movie/${id}/videos?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US`);
    const json=await data.json();
    setVideo(json.results)
   }

  return (
    video &&
    <div className='video'>
        {
            Object.values(video).map((idx)=>(
               idx.name==="Official Trailer" &&    
                    <iframe width="1200" height="600" src={`https://www.youtube.com/embed/${idx.key}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            ))
        }
    </div>
  )
}

export default Videos